import { authIsLoggedIn, authUsername, authSubscription } from './AuthStore';
import { authIsLoggedInDefault, authUsernameDefault, authSubscriptionDefault } from './AuthStoreDefaults';

export const resetAuthStore = () => {
	authIsLoggedIn.set(authIsLoggedInDefault);
	authUsername.set(authUsernameDefault);
	authSubscription.set(authSubscriptionDefault);
};
